import $ from 'jquery';

const ACTIVE = 'active';

const tabs = () => {
  const tabLink = $('.js-tab-link');
  const jsTabs = $('.js-tab');
  tabLink.on('click', ev => {
    ev.preventDefault();
    const self = ev.target;
    jsTabs.removeClass(ACTIVE);
    $(self.hash).addClass(ACTIVE);
    tabLink.removeClass(ACTIVE);
    self.classList.add(ACTIVE);
  });
};
export default tabs;



// WEBPACK FOOTER //
// ./src/scripts/modules/tabs.js